import React from "react";

import { useTranslation } from "react-i18next";
import {
	FrontendUserInfo,
	FrontendOrder,
	RosterUserInfo,
} from "node-library/dist/portal";
import UserCell from "./userCell";

interface Props {
	users: Array<RosterUserInfo>;
	goToViewUserDetails: (user: RosterUserInfo) => void;
	setDeleteUserConfirmOpen: React.Dispatch<React.SetStateAction<boolean>>;
	setProceedAction: React.Dispatch<React.SetStateAction<() => void>>;
}

export default function ViewUsersTable(props: Props) {
	const { t: translation } = useTranslation();

	const {
		users,
		goToViewUserDetails,
		setDeleteUserConfirmOpen,
		setProceedAction,
	} = props;

	const sampleCells: Array<React.ReactNode> = users
		? users.map((user: RosterUserInfo, index: number) => {
				return (
					<UserCell
						key={user.userId}
						user={user}
						goToViewUserDetails={() => goToViewUserDetails(user)}
						// discardUnstartedOrder={() => {
						// 	setProceedAction(() => () => discardUnstartedOrder(order));
						// 	setDiscardOrderConfirmOpen(true);
						// }}
					/>
				);
		  })
		: [];

	return <div className="view-order-grid-table">{sampleCells}</div>;
}
